<template>
  <div class="event-modal">
    <div class="modal-childrens">
      <span class="close-modal-event" @click.prevent="actionHideModal"><img class="img-close" src="https://res.cloudinary.com/dhcti0lrk/image/upload/v1615331605/globalwork/steps/cancel_wne8ik.png" alt=""></span>
      <div class="list-events-childrens">
        <div class="event-children" v-for="event in event.childrens" :key="event.id">
          <template v-if="event.name_key != null">
            <div class="event-children-icon">
              <template v-if="event.data.story_task == null">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#408530" class="bi bi-check" viewBox="0 0 16 16" v-if="event.status_event == 'finished'" alt="En espera">
                  <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>
                </svg>    
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#e95348" class="bi bi-stopwatch" viewBox="0 0 16 16" v-if="event.status_event == 'in_progress'" alt="En progreso">
                  <path d="M8.5 5.6a.5.5 0 1 0-1 0v2.9h-3a.5.5 0 0 0 0 1H8a.5.5 0 0 0 .5-.5V5.6z"/>
                  <path d="M6.5 1A.5.5 0 0 1 7 .5h2a.5.5 0 0 1 0 1v.57c1.36.196 2.594.78 3.584 1.64a.715.715 0 0 1 .012-.013l.354-.354-.354-.353a.5.5 0 0 1 .707-.708l1.414 1.415a.5.5 0 1 1-.707.707l-.353-.354-.354.354a.512.512 0 0 1-.013.012A7 7 0 1 1 7 2.071V1.5a.5.5 0 0 1-.5-.5zM8 3a6 6 0 1 0 .001 12A6 6 0 0 0 8 3z"/>
                </svg>                            
              </template>
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#408530" class="bi bi-chat-left-dots" viewBox="0 0 16 16" v-else>
                <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                <path d="M5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
              </svg>
            </div>
            <div class="event-children-content">
              <div class="event-children-title">{{nameArchives(event.name_key)}}</div>
              <div class="event-children-description">
                {{detailEvent(event)}}
              </div>
              <div class="event-children-date">
                <EventDate :date="event.created_at" />
              </div>                        
            </div>
          </template>
        </div>

        <template v-if="event.event_type == 'information_completed'">
          <template v-if="event.rules_incompleted_step_information_completed.documents.length > 0">
            <p class="title-rules-missing">Documentos</p>
            <RulesIncomplete :rules="event.rules_incompleted_step_information_completed.documents" />          
          </template>          
          <template v-if="event.rules_incompleted_step_information_completed.references.length > 0">
            <p class="title-rules-missing">Referencias</p>
            <RulesIncomplete :rules="event.rules_incompleted_step_information_completed.references" />          
          </template>                    
        </template>

        <template v-if="event.event_type == 'request_validations'">
          <template v-if="event.rules_incompleted_step_request_validations.length > 0">
            <p class="title-rules-missing">Solicitud de verificaciones</p>
            <RulesIncomplete :rules="event.rules_incompleted_step_request_validations" />
          </template>
        </template>

        <template v-if="event.event_type == 'verifications_response'">
          <template v-if="event.rules_incompleted_step_verifications_response.length > 0">
            <p class="title-rules-missing">Respuesta de verificaciones</p>
            <RulesIncomplete :rules="event.rules_incompleted_step_verifications_response" />
          </template>
        </template>

      </div>      
    </div>
  </div>
</template>

<script>
  import { eventBus } from './../../application'
  import EventDate from './EventDate.vue'
  import RulesIncomplete from './RulesIncomplete.vue'
  export default {
    props: {
      event: Object
    },
    methods: {
      actionHideModal() {
        eventBus.$emit('hideModal')
        eventBus.$emit('showContentVisible')
      },
      nameArchives (nameKey) {
        switch (nameKey) {
          case 'cv_upload':
            return 'Hoja de vida'
          case 'habeas_data_upload':
            return 'Habeas data'
          case 'academic_diploma_upload':
            return 'Diploma académico'
          case 'academic_certificate_upload':
            return 'Certificado académico'
          case 'work_certificate_upload':
            return 'Certificado laboral'
          case 'request_data_candidate_in_progress':
            return 'Solicitud de información al candidato'
          case 'academic_reference_request_validation':
            return 'Solicitud de verificación académica'
          case 'laboral_reference_request_validation':
            return 'Solicitud de verificación laboral'
          case 'family_reference_request_validation':
            return 'Solicitud de verificación de referencia familiar'
          case 'personal_reference_request_validation':
            return 'Solicitud de verificación de referencia personal'
          case 'academic_reference_created':
            return 'Referencia académica creada'
          case 'laboral_reference_created':
            return 'Referencia laboral creada'
          case 'family_reference_created':
            return 'Referencia familiar creada'
          case 'personal_reference_created':
            return 'Referencia personal creada'
          case 'academic_reference_verified':
            return 'Referencia académica verificada'                                                
          case 'laboral_reference_verified':
            return 'Referencia laboral verificada'                                                
          case 'family_reference_verified':
            return 'Referencia familiar verificada'                                                
          case 'personal_reference_verified':
            return 'Referencia personal verificada'
          case 'request_data_candidate_finished':
            return 'El candidato respondió la solicitud de información'
          case 'assignment_academic_finished':
            return 'Asignación académica'
          case 'assignment_personal_finished':
            return 'Asignación personal'
          case 'assignment_laboral_finished':
            return 'Asignación laboral'
          case 'assignment_antecedents_finished':
            return 'Asignación de antecedentes'                        
          default:
            return nameKey
        }
      },
      detailEvent (event) {
        if (event.data.story_task) {
          return event.data.observations
        } else {
          return event.translate_text_description_finished
        }        
      }
    },
    components: {
      EventDate,
      RulesIncomplete
    },
  }
</script>

<style scoped>

</style>